module.exports = __webpack_public_path__ + "static/media/valueAlert.56a58260.svg";